import { Location } from "./location";
export class LocationHierarchy {
	locations: Location[];
	version: number;
}